import ReactTooltip from 'react-tooltip';

import React from 'react';

const Tooltip = (props) => {
  const { children, type = 'light', place = 'top' } = props;
  return (
    <ReactTooltip place={place} type={type} effect="float" border {...props} data-multiline>
      {children}
    </ReactTooltip>
  );
};

export default Tooltip;
